import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Start from "./pages/start/Start";
import AddItem from "./pages/additem/AddItem";
import Preset from "./pages/preset/Preset";

export default class App extends React.Component {
  render() {
    return (
      <>
        <Router>
          <Routes>
            <Route path="/" element={<Start />} />
            <Route path="/additem" element={<AddItem />} />
            <Route path="/preset" element={<Preset />} />
          </Routes>
        </Router>
      </>
    );
  }
}
